import React, { Component } from 'react'
import { Checkbox, Popconfirm } from 'antd'

export default class IrreversibleCheckbox extends Component {
    constructor(props) {
        super(props)

        this.state = {
            visible: false
        }
    }

    handleVisibleChange(checked, visible) {
        const { disabled } = this.props

        if (checked || disabled) {
            this.setState({ visible: false })
        } else {
            this.setState({ visible })
        }
    }

    render() {
        const { checked, onChange, disabled } = this.props
        const { visible } = this.state

        return (
            <Popconfirm
            	visible={visible}
            	placement="bottom"
            	title="This action is irreversible, are you sure?"
            	onVisibleChange={this.handleVisibleChange.bind(this, checked)}
                onConfirm={onChange}
            >
        		<Checkbox checked={checked} disabled={disabled}/>
        	</Popconfirm>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Commons/IrreversibleCheckbox/IrreversibleCheckbox.js